module.exports = __webpack_public_path__ + "margarida_salomao--8f2a7ba7.jpg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/candidatos/margarida_salomao.jpg
// module id = 168
// module chunks = 0